import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Period Selection:", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id", "required"]
const _hoisted_5 = {
  key: 0,
  value: ""
}
const _hoisted_6 = ["value"]

import { onMounted, computed, watch } from 'vue';
import "@/types/Date";
import DatePeriod from '@/types/DatePeriod';
import useVModelDefaultVar from '@/services/composables/VModelDefaultVar';
import { marketSelection } from '@/services/helpers/Helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'PeriodSelector',
  props: {
    id: {},
    modelValue: {},
    hasNullSelector: { type: Boolean },
    trailingPeriod: { type: Boolean },
    showTitle: { type: Boolean },
    nullSelectorName: { default: 'All' },
    defaultRefDate: {},
    filter: {},
    required: { type: Boolean },
    updateOnPropertyChange: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const nullValue = new DatePeriod(null);
const periods = computed(()=>props.filter?generatePeriods(props.trailingPeriod).filter(props.filter):generatePeriods(props.trailingPeriod));
const periodSelection = useVModelDefaultVar(props, emits, 'modelValue', getDefault());
const nullVarWrap = computed({
    get() {
        return periodSelection.value.isValid() ? periodSelection.value : "";
    },
    set(val: "" | DatePeriod) {
        periodSelection.value = val==="" ? nullValue : val;
    }
});
onMounted(()=>{
    if (!props.modelValue?.isValid() && periodSelection.value !== nullValue) periodSelection.value = getDefault();
});
watch(
  () => props.updateOnPropertyChange,
  () => {
    periodSelection.value = nullValue;
  }
);
function getDefault() {
    if (props.hasNullSelector) return nullValue;
    const lastMonth = new Date().addMonths(-1);
    return new DatePeriod(lastMonth);
}
function generatePeriods(trailingPeriod) {
    const refDate = props.defaultRefDate ?? marketSelection.value === 'GB' ? new DatePeriod(2023,4) : new DatePeriod(2024,0);
    
    const date = trailingPeriod == true? new DatePeriod(new Date().addMonths(-1)) : new DatePeriod(new Date());

    const nMonths = date.diffMonths(refDate)+1;
    const listOfDates = new Array<DatePeriod>(nMonths);
    for (const i of new Array(nMonths).keys()) {
        listOfDates[i] = new DatePeriod(date);
        date.addMonths(-1);
    }
    return listOfDates;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ contents:!_ctx.showTitle, 'flex-col-centered selection':_ctx.showTitle })
  }, [
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id
        }, _hoisted_3, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nullVarWrap).value = $event)),
      class: "dropdown",
      required: _ctx.required
    }, [
      (_ctx.hasNullSelector)
        ? (_openBlock(), _createElementBlock("option", _hoisted_5, _toDisplayString(_ctx.nullSelectorName), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periods.value, (period) => {
        return (_openBlock(), _createElementBlock("option", { value: period }, _toDisplayString(period), 9, _hoisted_6))
      }), 256))
    ], 8, _hoisted_4), [
      [_vModelSelect, nullVarWrap.value]
    ])
  ], 2))
}
}

})